import {BsPlus} from "react-icons/bs";
import {AiFillCamera} from "react-icons/ai";
export const ImageButton = (props) => {
  return (
    <button onClick={props.onclick} className="default_button">
      <span><AiFillCamera size={56}/></span>
    </button>
  );
};
